import React from 'react'

import lang from '@/lang'

import PageWrapper from '@/modules/base/components/modalWizard/pageWrapper'
import { CONNECTION_TYPE_ONLINE } from '@/modules/client/constants'

const Finish = ({ onClose, connectionType, tenantId }) => {
  const isOnlineClient = connectionType === CONNECTION_TYPE_ONLINE
  const finishTitle = isOnlineClient ? lang.createClient.finish.titleOnline : lang.createClient.finish.titleOffline
  const finishText = isOnlineClient ? lang.createClient.finish.textOnline : lang.createClient.finish.textOffline
  const hidePrevButton = !!tenantId

  return (
    <PageWrapper
      heading={lang.createClient.finish.heading}
      title={finishTitle}
      text={finishText}
      onNextButtonClick={onClose}
      hidePrevButton={hidePrevButton}
    ></PageWrapper>
  )
}

export default Finish
